<template>
  <div class="container">
    <div class="searchBox_top">
      <el-button size="mini" type="primary" :disabled="preventManyClick" v-acl="MaterialEdit" @click="save">{{$t('common.save')}}</el-button>
      <el-button size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
      <!--关闭-->
    </div>
    <el-form label-width="200px" :model="materialForm" style="margin-top:10px" class="materialForm">
      <el-row :gutter="20">
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.eightBitCode.eightBitCode')" prop="eightBitCode">
            <!--8位码-->
            <el-input v-model="materialForm.eightBitCode" disabled style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.eightBitCode.eightBitCodeName')" prop="eightBitCodeName">
            <!--8位码名称-->
            <el-input v-model="materialForm.eightBitCodeName" disabled style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.foutboundFreightTaxAmount')" prop="foutboundFreightTaxAmount">
            <!--未来Outbound运费税额-->
            <el-input v-model="materialForm.foutboundFreightTaxAmount" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.foutboundFreightwotax')" prop="foutboundFreightwotax">
            <!--未来Outbound运费（不含税）-->
            <el-input v-model="materialForm.foutboundFreightwotax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.foutboundFreightwtax')" prop="foutboundFreightwtax">
            <!--未来Outbound运费（含税）-->
            <el-input v-model="materialForm.foutboundFreightwtax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.fstorageFeeTaxAmount')" prop="fstorageFeeTaxAmount">
            <!--未来仓储管理费税额-->
            <el-input v-model="materialForm.fstorageFeeTaxAmount" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.fstorageFeewotax')" prop="fstorageFeewotax">
            <!--未来仓储管理费（不含税）-->
            <el-input v-model="materialForm.fstorageFeewotax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.fstorageFeewtax')" prop="fstorageFeewtax">
            <!--未来仓储管理费（含税）-->
            <el-input v-model="materialForm.fstorageFeewtax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.ftransportFeeTaxAmount')" prop="ftransportFeeTaxAmount">
            <!--未来国内运费运费税额-->
            <el-input v-model="materialForm.ftransportFeeTaxAmount" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.ftransportFeewotax')" prop="ftransportFeewotax">
            <!--未来国内运费运费（不含税）-->
            <el-input v-model="materialForm.ftransportFeewotax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.ftransportFeewtax')" prop="ftransportFeewtax">
            <!--未来国内运费运费（含税）-->
            <el-input v-model="materialForm.ftransportFeewtax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.storageFeeTaxAmount')" prop="storageFeeTaxAmount">
            <!--仓储管理费税额-->
            <el-input v-model="materialForm.storageFeeTaxAmount" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.storageFeewotax')" prop="storageFeewotax">
            <!--仓储管理费（不含税）-->
            <el-input v-model="materialForm.storageFeewotax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.storageFeewtax')" prop="storageFeewtax">
            <!--仓储管理费（含税）-->
            <el-input v-model="materialForm.storageFeewtax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.transportFeeTaxAmount')" prop="transportFeeTaxAmount">
            <!--国内运费税额-->
            <el-input v-model="materialForm.transportFeeTaxAmount" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.transportFeewotax')" prop="transportFeewotax">
            <!--国内运费（不含税）-->
            <el-input v-model="materialForm.transportFeewotax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="1" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('base.material.transportFeewtax')" prop="transportFeewtax">
            <!--国内运费（含税）-->
            <el-input v-model="materialForm.transportFeewtax" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="action-btn-row">
      <el-button size="mini" type="primary" v-acl="MaterialEdit" @click="addDC">{{$t('common.add')}}</el-button>
      <el-button size="mini" type="danger" v-acl="MaterialEdit" @click="delDC">{{$t('common.del')}}</el-button>
    </div>
    <el-table :data="dcsData" ref="dcsData" border highlight-current-row>
      <el-table-column type="selection"></el-table-column>
      <el-table-column sortable :label="$t('base.dc.dcName')" prop="tmDcId">
        <template slot-scope="scope">
          <ic-select :table-fields="[{table:'BASE',field:'DC'}]" filterable clearable v-model="scope.row.tmDcId"></ic-select>
        </template>
      </el-table-column>
      <el-table-column sortable :label="$t('base.material.dcTime')">
        <!--鲜货准备时间-->
        <template slot-scope="scope">
          <el-input v-model="scope.row.dcTime" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
        </template>
      </el-table-column>
      <el-table-column sortable :label="$t('base.material.spTime')">
        <!--inbound物流运输时间-->
        <template slot-scope="scope">
          <el-input v-model="scope.row.spTime" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
        </template>
      </el-table-column>
      <el-table-column sortable :label="$t('base.material.icTime')">
        <!--供应商准备时间-->
        <template slot-scope="scope">
          <el-input v-model="scope.row.icTime" type="number" clearable oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { materialService } from "@/api/base-data/material";
import IcSelect from "@/components/common/icSelect";
export default {
  name: "material-detail",
  components: { IcSelect },
  data() {
    return {
      materialForm: {},
      dcsData: [],
      materilId: '',
      preventManyClick: false,//防止重复点击
    }
  },
  created() {
    this.materilId = this.$route.query.materilId;
    this.getDetail(this.$route.query.materilId)
  },
  methods: {
    getDetail(id) {
      let that = this;
      materialService.getMaterilDetail(id).then((res) => {
        this.materialForm = res.data.material
        if (res.data.dcs.length > 0) {
          //循环数组添加删除用的标示
          for (let i = 0, len = res.data.dcs.length; i < len; i++) {
            res.data.dcs[i].delIds = i;
          }
        }
        this.dcsData = res.data.dcs
      });
    },
    save() {
      this.preventManyClick = true
      let that = this;
      let data = {
        material: that.materialForm,
        dcs: that.dcsData,
      }
      materialService.saveMateril(that.materilId, data).then((res) => {
        console.log(res);
        if (res.code == '200') {
          that.preventManyClick = false
          that.$message({ message: that.$t("common.saveSuccess"), type: "success" });
        } else {
          that.$message({ message: res.msg, type: "error" });
        }
      });
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    addDC() {
      let len = this.dcsData.length;
      var list = {
        delIds: len
      };
      this.dcsData.push(list);
    },
    delDC() {
      let that = this;
      let list = this.dcsData;
      let val = this.$refs.dcsData.selection;
      if (val.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return;
      } else {
        val.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.dcsData = list;
    },


  },
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
.materialForm .el-input {
  width: 200px;
}
</style>
